/** Delay before typing in the /browse search box triggers a Typesense search. */
export const BROWSE_SEARCH_DEBOUNCE_MS = 500;

/**
 * InstantSearch `searchBox` queryHook that debounces Typesense requests while
 * the user types. Call `cancel()` on unmount to clear any pending timer.
 *
 * @param {number} [delayMs]
 * @returns {((query: string, search: (value: string) => void) => void) & { cancel: () => void }}
 */
export function createDebouncedQueryHook(delayMs = BROWSE_SEARCH_DEBOUNCE_MS) {
  let timerId = null;

  const queryHook = (query, search) => {
    if (timerId != null) {
      clearTimeout(timerId);
      timerId = null;
    }

    // Clearing the box should refresh results immediately (reset button / empty).
    if (!query) {
      search(query);
      return;
    }

    timerId = setTimeout(() => {
      timerId = null;
      search(query);
    }, delayMs);
  };

  queryHook.cancel = () => {
    if (timerId != null) {
      clearTimeout(timerId);
      timerId = null;
    }
  };

  return queryHook;
}
